export default __webpack_public_path__ + "static/media/stethoscope.ba29bb25.svg";